import React from "react";
import { FaHeadphones, FaUndoAlt } from "react-icons/fa";
import styles from "./CalibrationRequestForm.module.scss";
import oreilleArtificielleImg from "../../pics/request-calibration/oreilles-artificielle.jpg";

export const TransducerStep = ({
  t,
  selectedTransducers,
  onTransducerChange,
  onNext,
}) => (
  <div className={styles.formLayout}>
    <div className={styles.headerInfo}>
      <h4>{t("calibration_request.transducers_title")}</h4>
      <p>{t("calibration_request.transducers_desc")}</p>
    </div>

    <div className={styles.transducerGroup}>
      {[
        { value: "bone_conduction", label: t("calibration_request.transducer_bone") },
        { value: "headphones", label: t("calibration_request.transducer_headphones") },
        { value: "inserts", label: t("calibration_request.transducer_inserts") },
        { value: "free_field", label: t("calibration_request.transducer_free_field") },
      ].map((item) => (
        <label key={item.value} className={styles.transducerOption}>
          <input
            type="radio"
            name="transducer"
            checked={selectedTransducers.includes(item.value)}
            onChange={() => onTransducerChange(item.value)}
          />
          <span>{item.label}</span>
        </label>
      ))}
    </div>

    <button
      className={styles.submitBtn}
      onClick={onNext}
      disabled={selectedTransducers.length === 0}
      type="button"
    >
      {t("calibration_request.next_step")}
    </button>
  </div>
);

export const HasEarsStep = ({ t, onHasEars, onMissingArtificialEars }) => (
  <div className={styles.formLayout}>
    <div className={styles.headerInfo}>
      <img
        src={oreilleArtificielleImg}
        alt={t("calibration_request.ears_choose_title")}
        className={styles.headerImage}
      />
      <h4>{t("calibration_request.has_ears_title")}</h4>
      <p>{t("calibration_request.has_ears_desc")}</p>
    </div>

    <div className={styles.earsChoiceGroup}>
      <button className={styles.earsChoiceBtn} onClick={onHasEars} type="button">
        <FaHeadphones className={styles.icon} />
        <div className={styles.earsChoiceText}>
          <strong>{t("calibration_request.has_ears_yes")}</strong>
          <span>{t("calibration_request.has_ears_yes_hint")}</span>
        </div>
      </button>

      <button
        className={styles.earsChoiceBtn}
        onClick={onMissingArtificialEars}
        type="button"
      >
        <FaUndoAlt className={styles.icon} />
        <div className={styles.earsChoiceText}>
          <strong>{t("calibration_request.has_ears_no")}</strong>
          <span>{t("calibration_request.has_ears_no_hint")}</span>
        </div>
      </button>
    </div>

    {/* Option de retour des oreilles artificielles */}
    {/* <div className={styles.returnEarsLink}>
      <p>{t("calibration_request.return_ears_question")}</p>
      <button
        className={styles.linkBtn}
        onClick={() => { setEffectiveType("ears_return"); setStep(STEPS.FORM); }}
        type="button"
      >
        {t("calibration_request.return_ears_action")}
      </button>
    </div> */}
  </div>
);

export const TutorialStep = ({ t, selectedTransducers, onClose }) => (
  <div className={styles.formLayout}>
    <div className={styles.headerInfo}>
      <h4>{t("calibration_request.tutorial_title")}</h4>
      <p>{t("calibration_request.tutorial_desc")}</p>
    </div>

    <div className={styles.tutorialVideos}>
      {selectedTransducers.includes("headphones") && (
        <div className={styles.tutorialVideoCard}>
          <h5>{t("calibration_request.tutorial_headphones")}</h5>
          <iframe
            src="https://www.youtube.com/embed/RQqMR2s5hos"
            title={t("calibration_request.tutorial_headphones")}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={styles.tutorialIframe}
          />
        </div>
      )}
      {selectedTransducers.includes("inserts") && (
        <div className={styles.tutorialVideoCard}>
          <h5>{t("calibration_request.tutorial_inserts")}</h5>
          <iframe
            src="https://www.youtube.com/embed/ZUtmdMd3VkI"
            title={t("calibration_request.tutorial_inserts")}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={styles.tutorialIframe}
          />
        </div>
      )}
      {selectedTransducers.includes("free_field") && (
        <div className={styles.tutorialVideoCard}>
          <h5>{t("calibration_request.tutorial_free_field")}</h5>
          <iframe
            src="https://www.youtube.com/embed/4sBqZDpN8Pk"
            title={t("calibration_request.tutorial_free_field")}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={styles.tutorialIframe}
          />
        </div>
      )}
    </div>

    <button className={styles.doneBtn} onClick={onClose} type="button">
      {t("calibration_request.close")}
    </button>
  </div>
);

export const SuccessStep = ({ t, onClose }) => (
  <div className={styles.successMsg}>
    <p>{t("calibration_request.success")}</p>
    <button className={styles.doneBtn} onClick={onClose} type="button">
      {t("calibration_request.close")}
    </button>
  </div>
);
